import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type K2Portfolio = {
  id: number;
  client: string;
  vehicle: string;
  account_name: string;
  name: string;
  devise: string;
  bank_name: string;
  account_type: string;
  investment_type: string;
  contract_name: string;
  code: string;
  has_pdf_bank_page: string;
  reporting_currency: string;
  collateral: boolean;
  has_transactions?: boolean;
};

export const porfolios_columns: ColumnDef<K2Portfolio>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "client",
    header: "Client",
  },
  {
    accessorKey: "vehicle",
    header: "Véhicule / Bénéficiaire du compte",
  },
  {
    accessorKey: "account_name",
    header: "Groupe de comptes",
  },
  {
    accessorKey: "name",
    header: "Compte",
  },
  {
    accessorKey: "currency",
    header: "Devise du portefeuille",
  },
  {
    accessorKey: "reporting_currency",
    header: "Devise de reporting",
  },
  {
    accessorKey: "bank_name",
    header: "Banque",
  },
  {
    accessorKey: "account_type",
    header: "Type de compte",
  },
  {
    accessorKey: "investment_type",
    header: "Type d'investissement",
  },
  {
    accessorKey: "contract_name",
    header: "Nom du contrat",
  },
  {
    accessorKey: "code",
    header: "Code",
  },
  {
    accessorKey: "has_pdf_bank_page",
    header: () => <div className="text-center">PDF</div>,
    cell: ({ getValue }) =>
      getValue() && (
        <div className="flex justify-center">
          <CheckIcon />
        </div>
      ),
  },
  {
    accessorKey: "collateral",
    header: "Compte-titres nanti",
    cell: ({ getValue }) =>
      getValue() && (
        <div className="flex justify-center">
          <CheckIcon />
        </div>
      ),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;

      return (
        <div className="flex gap-3 justify-end">
          <ExternalLink
            href={toWorkspacePath("/admin/k2/k2_transactions")}
            queryParams={{ k2_portfolios_id_equal: row.getValue("id") }}
            className={`text-xs ${
              !hasTransactions ? "invisible pointer-events-none" : ""
            }`}
            underline="hover"
          >
            Transactions
          </ExternalLink>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<K2Portfolio>(porfolios_columns)
